import { render, staticRenderFns } from "./NewsBanner.vue?vue&type=template&id=c1388750&"
import script from "./NewsBanner.vue?vue&type=script&lang=js&"
export * from "./NewsBanner.vue?vue&type=script&lang=js&"
import style0 from "./NewsBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports